<template>
  <div class="number-modal">
    <div class="number-modal-body">
      <div class="number-body" style="margin-top: 20px">
        <div class="number-body-close">
          <img
            src="@/assets/icon/shapes-and-symbols.png"
            alt=""
            @click="remove"
          />
        </div>
        <div class="number-body-title">
          <p>Утасны дугаар баталгаажуулах</p>
        </div>
        <div class="number-body-form">
          <form action="" @submit.prevent="sendNumber">
            <input
              type="text"
              placeholder="Утасны дугаар оруулна уу "
              v-model="number"
            />
            <div class="number-error" v-if="error">
              <p>{{ errorMessage }}</p>
            </div>
            <input
              type="submit"
              value="БАТАЛГААЖУУЛАХ"
              class="btn login-btn"
              :disabled="isDisabled"
              :class="{ someSpace: error }"
            />
          </form>
        </div>
      </div>
      <div class="number-footer">
        <p>
          Утасны дугаар оруулснаар дараагийн удаад нэвтрэх түлхүүр үг болох
          боломжтой.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: ["phone"],
  data() {
    return {
      number: "",
      error: false,
      errorMessage: "",
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    sendNumber() {
      this.isDisabled = true;
      this.$insProgress.start();
      var userNumber = this.number.replace(/\s/g, "");
      var isnum = /^\d+$/.test(userNumber);
      if (userNumber.length == 8 && isnum) {
        var tokenId = localStorage.getItem("authToken");
        if (tokenId == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var typeValue = this.number;
        var userOwnData = this.$auth.getMe();
        var cardHolderKey = userOwnData.cardHolderInfId;
        this.$bonusApi
          .post(
            `auth/send/code/phone`,
            {
              tokenId,
              phoneNumber: typeValue,
              cardHolderKey,
              type: "IdPhone",
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data === true) {
              this.$emit("close", typeValue);
              this.$insProgress.finish();
            } else {
              this.errorMessage = "Код илгээхэд алдаа гарлаа.";
              this.error = true;
              this.isDisabled = false;
              this.$insProgress.finish();
            }
          })
          .catch((error) => {
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Код илгээхэд алдаа гарлаа.";
            this.error = true;
            this.isDisabled = false;
            this.$insProgress.finish();
          });
      } else {
        this.error = true;
        this.errorMessage = "Та зөвхөн 8 оронтой тоо оруулна уу.";
        this.isDisabled = false;
        this.$insProgress.finish();
      }
    },
    remove() {
      this.$emit("remove");
    },
  },
};
</script>

<style scoped>
.number-body-close {
  padding-left: 54px;
  text-align: right;
  padding-right: 33px;
  margin-bottom: 10px;
}
.number-body-close img {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
</style>
